<template lang='slm'>
  div
    carousel :items='carousel'
    .section.stream.bg-white v-show='liveYoutubeId'
      h2.mb-3 Прямой эфир
      .iframe-container
        .iframe
          iframe :src='"https://www.youtube.com/embed/"+liveYoutubeId' frameborder="0" allow="encrypted-media" allowfullscreen=''
    .section
      .container.d-inline-block
        h2.color-dark Добро пожаловать в Мелитопольскую Христианскую Церковь
        p.font-weight-medium Мелитопольская Христианская Церковь - место для встречи с Богом.
        p Рожденная по откровению от Бога и возросшая в поклонении и молитвах — наша церковь стала для нас семьей и армией, местом утешения и обучения, дорогой, по которой мы следуем во Святом Духе.
        p Наша Главная задача — быть «смоковницей», приносящей плод. Наша цель — спасти грешников в нашем гopoде и войти в небеса, наше оружие в борьбе с дьяволом — пост, молитва и проповедь Благой Вести. Мы уповаем на нерушимое Слово Божье и готовы идти до конца в вере нашему Спасителю. Евангелия в нашем служение. Мы верим в великое призвание для нашей церкви и для каждого из нас
        div.color-dark
          h2.font-weight-medium.mb-1 Наше собрание
          span.font-weight-extra-bold Воскресенье – 14:00
          h2.mt-3 Контакты
          .d-inline-block.mt-2 style='width:20rem'
            div
              / router-link.my-btn.mr-4 to='#' Расписание
              .d-block.d-lg-none
                a.my-btn.w-100 :href='mapHrefUrl' target='_blank' rel='noopener noreferrer' Как добраться
              .d-none.d-lg-block
                a.my-btn.w-100 href='#' @click.prevent='openMapModal' Как добраться
                modal ref='mapModal' title='Как добраться' size='xl' :showConfirmButton='false'
                  a.my-btn.mb-3 :href='mapHrefUrl' target='_blank' rel='noopener noreferrer' Открыть в новой вкладке
                  iframe.d-none.d-lg-block width='100%' height='300px' frameborder="0" style="border:0" :src='modalMapUrl'
            .mt-2
            a.my-btn.font-weight-medium.w-100 href='tel:+380988778800' +38 (098) 877 88 00
    .section.pastor
      .container-fluid.d-block.d-md-none.pastor-container
        .text.text-left.font-weight-light
          span Виденье церкви в том чтобы достигнуть максимально возможного количества людей в мире, строя Церковь, полагая Иисуса Христа в основании, проповедуя чистое бескомпромиссное Евангелие, выполняя великое поручение и взращивая учеников, строя большое красивое здание для служения и наполняя этот зал людьми.
      .container.d-none.d-md-block
        .text.text-left.font-weight-light
          span Виденье церкви в том чтобы достигнуть максимально возможного количества людей в мире, строя Церковь, полагая Иисуса Христа в основании, проповедуя чистое бескомпромиссное Евангелие, выполняя великое поручение и взращивая учеников, строя большое красивое здание для служения и наполняя этот зал людьми.
    .section.bg-white
      router-link to='/services'
        h2.mb-0 Служения
      h3.mt-1.mb-4 Выбери что-то для себя
      .services.container
        .row
          router-link.service.col-6.col-md-3.mb-4 to='/services#kids'
            img src='~img/services/kids.jpg' alt=''
            h3.font-weight-extra-bold Kids
          router-link.service.col-6.col-md-3.mb-4 to='/services#boger'
            img src='~img/services/boger.jpg' alt=''
            h3.font-weight-extra-bold Boger
          router-link.service.col-6.col-md-3.mb-4 to='/services#youth'
            img src='~img/services/youth.jpg' alt=''
            h3.font-weight-extra-bold Youth
          router-link.service.col-6.col-md-3.mb-4 to='/services#woman'
            img src='~img/services/woman.jpg' alt=''
            h3.font-weight-extra-bold Woman
    .section.color-white(style='background-color:#B2984D')
      router-link to='/next_steps'
        h2.mb-0 Следующие шаги
      h3.mt-1.mb-4 Станьте тем, кем вы были созданы
      table.next-steps.mx-auto
        tbody
          //- md and more
          tr.d-none.d-md-table-row.border-bottom
            td.border-right
              router-link.d-inline-block to='/next_steps#домашние_группы' Домашняя группа
            td
              router-link.d-inline-block to='/next_steps#альфа_курс' Библейский класс
          tr.d-none.d-md-table-row
            td.border-right
              router-link.d-inline-block to='/next_steps#водное_крещение' Водное крещение
            td
              router-link.d-inline-block to='/next_steps#волонтёрство' Стань волонтёром

          //- less then md
          tr.d-table-row.d-md-none.border-bottom
            td
              router-link.d-inline-block to='/next_steps#домашние_группы' Домашняя группа
          tr.d-table-row.d-md-none.border-bottom
            td
              router-link.d-inline-block to='/next_steps#альфа_курс' Библейский класс
          tr.d-table-row.d-md-none.border-bottom
            td
              router-link.d-inline-block to='/next_steps#водное_крещение' Водное крещение
          tr.d-table-row.d-md-none
            td
              router-link.d-inline-block to='/next_steps#волонтёрство' Стань волонтёром
    .section.bg-white v-if='audioPreachings.length'
      .container.text-left
        .d-flex.mb-4.flex-wrap.flex-sm-nowrap
          h2.mb-0.flex-grow Аудиопроповеди
          router-link.d-flex.mt-1.mb-1.text-nowrap to='/audio_preachings'
            icon.mr-2 name='bars'
            | Смотреть больше
        .audios.row
          .col.text-center v-for='audio in audioPreachings'
            audio-preach :image-id='audio.imageId' :title='audio.title' :speaker='audio.speaker' :date='audio.date' :file-id='audio.fileId' :duration='audio.duration'
    .section.music v-if='albums.length'
      .bg :style='{ backgroundImage: "url(/api/file/" + albums[0].coverId + ")" }'
      .container.text-left.color-black
        .d-flex.mb-4.flex-wrap.flex-sm-nowrap
          h2.mb-0.flex-grow Музыка
          router-link.d-flex.mt-1.mb-1.text-nowrap to='/music'
            icon.mr-2 name='bars'
            | Все альбомы
        .albums.row
          .col.text-center.mb-2 v-for='album in albums'
            router-link :to='"/music#" + encodeURIComponent(album.hash)'
              music-album :image-id='album.coverId' :title='album.title' :artist='album.artist' :year='album.year'
    .section.give
      h2 Пожертвования
      .container
        div Давайте, и дастся вам. Полной мерой, утрясенной и пересыпающейся через край, вам будет отсыпано. Какой мерой вы мерите, такой отмерят и вам.
        .text-right.mb-2
          em Евангелие от Луки 6:38
        .d-block
          a.my-btn :href='$parent.givingsUrl' target='_blank' rel='noopener noreferrer' Пожертвовать
    .section.question
      h2 Задать вопрос анонимно
      .container
        div Вы можете анонимно задать любой интересующий вас вопрос и специальная команда служителей ответит вам на него.
      .d-block.mt-3
        router-link.my-btn to='/question' Задать вопрос
    .section.social
      .container
        .row
          .col
            a href='https://www.instagram.com/mlt.church/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/instagram'
              span Church
            a href='https://www.instagram.com/mlt.kids/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/instagram'
              span Kids
            a href='https://www.instagram.com/mlt.worship/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/instagram'
              span Worship
            a href='https://www.instagram.com/mlt.youth/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/instagram'
              span Youth
          .col
            a href='https://www.facebook.com/mlt.church/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/facebook'
              span Church
            a href='https://www.facebook.com/NG-Kids-1769946326637652/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/facebook'
              span Kids
            a href='https://www.facebook.com/mlt.youth/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/facebook'
              span Youth
          .col
            a href='https://www.youtube.com/c/mlt_church/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/youtube'
              span Church
            a href='https://www.youtube.com/user/4UyouthTV/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/youtube'
              span Youth
            a href='https://www.youtube.com/channel/UCC8PWVuS3qT6f2qv8NpXyMg/' target='_blank' rel='noopener noreferrer'
              icon.mr-2 name='brands/youtube'
              span Worship
</template>

<style lang='stylus' scoped>
.section
  h2:first-child
    margin-top 0px
  &:not(.carousel):not(.copyright):not(:first-child)
    padding-top 32px
    padding-bottom 32px
  &.stream
    // BUG to scroll over iframe:
    // https://www.apus-peru.com/
    // https://jsfiddle.net/th0LxLbv/2/
    .iframe-container
      display flex
      justify-content center
      .iframe
        position relative
        width 95%
        @media (min-width: 992px)
          max-width 90%
        &:before
          padding-top 56.25% // 16:9
          display block
          content ''
          width 100%
          max-height 100vh
        iframe
          position absolute
          top 0
          left 0
          width 100%
          height 100%
  &.pastor
    background-image url('~img/pastor.png')
    background-position 85% center
    background-repeat no-repeat
    background-size cover
    padding-bottom 64px !important
    padding-top 0px !important
    @media (min-width: 768px)
      padding-top 64px !important
    .pastor-container
      height 450px * 1.5
      @media (max-width: 450px)
        height 150vw
        font-size 4vw
        line-height normal
        padding-right 0
        padding-left  0
    .text
      background-color rgba(256,256,256,0.4)
      padding 16px
      color black
      @media (min-width: 992px)
        margin-left 12rem
      @media (min-width: 768px)
        line-height 28px
        font-size 23px
        max-width 330px
  .services
    .service
      img
        width 100%
        border-radius 50%
      h3
        margin-top 18px
        @media (min-width: 768px)
          margin-top 24px
  table.next-steps
    border-collapse collapse
    border-spacing 0
    border-color white
    td
      padding 32px
      font-weight 600
  &.music
    .bg
      position absolute
      top -10%
      left -10%
      width 120%
      height 120%
      background-position center center
      background-repeat no-repeat
      background-size cover
      filter blur(25px)
      z-index -1
  &.give
    iframe
      border none
      width 100%
      height 580px
  &.question
    background-color white
  &.social
    padding-top 24px
    padding-bottom 24px
    background-color dark-color
    display flex
    color white
    .col
      display flex
      flex-direction column
      a
        display flex
        align-items center
        margin-bottom 4px
    span
      white-space nowrap
</style>

<script>
import gql from 'graphql-tag';

import Carousel from '@/components/Carousel';
import AudioPreach from '@/components/AudioPreach';
import MusicAlbum from '@/components/MusicAlbum';
import Modal from '@/components/Modal';

export default {
  components: {
    Carousel, AudioPreach, MusicAlbum, Modal,
  },
  name: 'IndexPage',
  data() {
    return {
      carousel: [],
      liveYoutubeId: '',
      audioPreachings: [],
      albums: [],
      modalMapUrl: 'about:blank',
      mapHrefUrl: 'https://goo.gl/maps/mKSKwd3FZZ62',
      mapModalUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10916.386471336315!2d35.3989041!3d46.8417879!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x427f5fde0063d9b3!2z0J3QvtCy0L7QtSDQv9C-0LrQvtC70LXQvdC40LU!5e0!3m2!1sru!2sua!4v1555409301284!5m2!1sru!2sua',
    };
  },
  methods: {
    openMapModal() {
      this.modalMapUrl = this.mapModalUrl;
      this.$refs.mapModal.open();
    },
  },
  apollo: {
    data: {
      query: gql`{ carousel { imageId squareImageId title speaker datetime } liveYoutubeId audioPreachings(limit: 4) { imageId title speaker date fileId duration } albums(limit: 3) { coverId title artist year hash } }`,
      update(data) {
        this.carousel = data.carousel;
        this.liveYoutubeId = data.liveYoutubeId;
        this.audioPreachings = data.audioPreachings;
        this.albums = data.albums;
      },
    },
  },
};
</script>
